import Vue from 'vue';
import Vuex from 'vuex';

import basket from '@/_vue/store/modules/basket';
import filters from '@/_vue/store/modules/filters';
import global from '@/_vue/store/modules/global';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        basket,
        filters,
        global,
    },
    strict: process.env.NODE_ENV !== 'production',
});
